let state = {
 
    allAvisosDisciplina:'',
    allchamadoaluno:'',
    allrespostaschamados:'',
    setchamado:'',
    allChamadosAlunos:'',
    allrespostaschamadosdisciplina:'',
    allChamadosAlunosDisciplina:'',
    setCalendarioAcademico:''
    
}

export default state